module.exports = __webpack_public_path__ + "img/jeze.jpg.mini.69cc3725.jpg";